import React, { useState } from 'react';
import styled from 'styled-components';

const Card = ({ title, description, children, githubLink, websiteLink }) => {
  const [showModal, setShowModal] = useState(false);

  const handleCardClick = (e) => {
    // Don't open modal if clicking the GitHub icon or View Project button
    if (e.target.closest('.github-icon') || e.target.closest('.see-more')) {
      return;
    }
    if (websiteLink || githubLink) {
      setShowModal(true);
    }
  };

  const handleLinkClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    setShowModal(false);
  };

  return (
    <StyledWrapper>
      <div className="parent">
        <div className="card" onClick={handleCardClick}>
          <div className="content-box">
            <span className="card-title">{title || '3D Card'}</span>
            <p className="card-content">
              {description || 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'}
            </p>
            {children}
          </div>
          <div className="date-box">
            {githubLink && (
              <a href={githubLink} target="_blank" rel="noopener noreferrer" className="github-icon" title="View on GitHub">
                <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>
      
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Choose Link</h3>
            <div className="modal-buttons">
              {websiteLink && (
                <button className="modal-btn website-btn" onClick={() => handleLinkClick(websiteLink)}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                  </svg>
                  View Website
                </button>
              )}
              {githubLink && (
                <button className="modal-btn github-btn" onClick={() => handleLinkClick(githubLink)}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                  </svg>
                  View GitHub
                </button>
              )}
            </div>
            <button className="modal-close" onClick={() => setShowModal(false)}>Cancel</button>
          </div>
        </div>
      )}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  width: 100%;
  display: block;

  .parent {
    width: 100%;
    padding: 8px;
    perspective: 1000px;
    box-sizing: border-box;
  }

  .card {
    position: relative;
    padding-top: 50px;
    /* border-radius: 10px; */
    border: 3px solid #0a0a0a;
    transform-style: preserve-3d;
    background: linear-gradient(135deg, #0000 18.75%, #1a1a2e 0 31.25%, #0000 0),
      repeating-linear-gradient(45deg, #1a1a2e -6.25% 6.25%, #0a0a0a 0 18.75%);
    background-size: 60px 60px;
    background-position:
      0 0,
      0 0;
    background-color: #0a0a0a;
    width: 100%;
    box-shadow: rgba(139, 92, 246, 0.4) 0px 30px 30px -10px;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
  }

  .card:hover {
    background-position:
      -100px 100px,
      -100px 100px;
    transform: rotate3d(0.5, 1, 0, 30deg);
  }

  .content-box {
    background: linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%);
    /* border-radius: 10px 100px 10px 10px; */
    transition: all 0.5s ease-in-out;
    padding: 65px 25px 25px 25px;
    min-height: 300px;
    overflow: hidden;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
    width: 100%;
  }

  .content-box .card-title {
    display: block;
    color: #ffffff;
    font-size: 22px;
    font-weight: 900;
    transition: all 0.5s ease-in-out;
    transform: translate3d(0px, 0px, 50px);
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    width: 100%;
  }

  .content-box .card-title:hover {
    transform: translate3d(0px, 0px, 60px);
  }

  .content-box .card-content {
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: #ffffff;
    transition: all 0.5s ease-in-out;
    transform: translate3d(0px, 0px, 30px);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
    max-width: 100%;
  }

  .content-box .card-content:hover {
    transform: translate3d(0px, 0px, 60px);
  }

  .content-box .see-more {
    cursor: pointer;
    margin-top: 1rem;
    display: inline-block;
    font-weight: 700;
    font-size: 10px;
    text-transform: uppercase;
    color: #0a0a0a;
    text-decoration: none;
    /* border-radius: 5px; */
    background: #ffffff;
    padding: 0.5rem 0.7rem;
    transition: all 0.5s ease-in-out;
    transform: translate3d(0px, 0px, 20px);
  }

  .content-box .see-more:hover {
    transform: translate3d(0px, 0px, 60px);
  }

  .date-box {
    position: absolute;
    top: 30px;
    right: 30px;
    height: 70px;
    width: 70px;
    background: #0a0a0a;
    border: 2px solid #ffffff;
    /* border-radius: 10px; */
    padding: 10px;
    transform: translate3d(0px, 0px, 80px);
    box-shadow: rgba(100, 100, 111, 0.2) 0px 17px 10px -10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .date-box .github-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    transition: all 0.3s ease;
    transform: translate3d(0px, 0px, 20px);
  }

  .date-box .github-icon:hover {
    color: #a855f7;
    transform: translate3d(0px, 0px, 40px) scale(1.15);
  }

  .date-box .github-icon svg {
    width: 32px;
    height: 32px;
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.2s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .modal-content {
    background: linear-gradient(135deg, #1a1a2e 0%, #0a0a0a 100%);
    border: 2px solid #8b5cf6;
    border-radius: 16px;
    padding: 2rem;
    min-width: 320px;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(139, 92, 246, 0.4);
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .modal-title {
    color: #ffffff;
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 1.5rem 0;
    text-align: center;
  }

  .modal-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .modal-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    border: 2px solid;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    background: transparent;
  }

  .website-btn {
    color: #a855f7;
    border-color: #a855f7;
  }

  .website-btn:hover {
    background: #a855f7;
    color: #ffffff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(168, 85, 247, 0.4);
  }

  .website-btn svg {
    width: 20px;
    height: 20px;
  }

  .github-btn {
    color: #ffffff;
    border-color: #ffffff;
  }

  .github-btn:hover {
    background: #ffffff;
    color: #0a0a0a;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
  }

  .github-btn svg {
    width: 20px;
    height: 20px;
  }

  .modal-close {
    width: 100%;
    padding: 0.75rem;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .modal-close:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.5);
  }

  @media (max-width: 768px) {
    .parent {
      width: 100%;
      max-width: 380px;
    }

    .date-box {
      height: 60px;
      width: 60px;
    }

    .date-box .github-icon svg {
      width: 28px;
      height: 28px;
    }

    .modal-content {
      min-width: 280px;
      padding: 1.5rem;
    }

    .modal-title {
      font-size: 1.3rem;
    }
  }

  @media (max-width: 480px) {
    .parent {
      width: 100%;
      max-width: 320px;
    }

    .content-box {
      padding: 50px 20px 20px 20px;
    }

    .card-title {
      font-size: 20px !important;
    }

    .card-content {
      font-size: 12px !important;
    }

    .date-box {
      height: 55px;
      width: 55px;
      top: 25px;
      right: 25px;
    }

    .date-box .github-icon svg {
      width: 24px;
      height: 24px;
    }

    .modal-content {
      min-width: 260px;
      padding: 1.25rem;
    }

    .modal-title {
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }

    .modal-btn {
      padding: 0.85rem 1.25rem;
      font-size: 0.9rem;
    }
  }
`;

export default Card;
